import React, { Component } from "react";
import PropTypes from "prop-types";

import validationRules from "../../../core/validationRules";

import Group from "./Group";
import Icon from "../../Icon/Icon";

class Base extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onError: PropTypes.func,
    validators: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.func
    ]),
    required: PropTypes.bool,
    filters: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    attachInputComponent: PropTypes.func,
    detachInputComponent: PropTypes.func,
    errorText: PropTypes.string,
    requiredErrorText: PropTypes.string,
    parentName: PropTypes.string,
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array
    ]),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array
    ]),
    errors: PropTypes.array,
    // EXPERIMENTAL SHIT
    valueTransformIn: PropTypes.func,
    valueTransformOut: PropTypes.func,
    subfieldsQuery: PropTypes.func,
    autoComplete: PropTypes.string
  };

  static defaultProps = {
    errorText: "This field is invalid.",
    requiredErrorText: "This field is required.",
    parentName: "",
    value: "",
    defaultValue: null,
    autoComplete: ""
  };

  constructor(...args) {
    super(...args);

    let value;
    if (
      (this.props.defaultValue !== null &&
        Object.keys(this.props.value).length === 0 &&
        this.props.value.constructor === Object) ||
      this.props.value === ""
    ) {
      value = this.props.defaultValue;
    }

    if (this.props.value != null) {
      value = this.props.value;
    }

    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      focus: false,
      value,
      passwordType: "",
      errors: []
    };
  }

  componentDidMount() {
    if (this.props.attachInputComponent) {
      this.props.attachInputComponent(this);
    }
    if (this.inputClass === "password") {
      this.setState({ passwordType: this.inputClass });
    }
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }

    if (this.props.required && !nextProps.required && this.state.errors.length) {
      this.setState({ errors: [] });
    }

    // TODO: do any of the other props values that have state need to be updated here?
    // we might be able to get away from setting errors
  }

  componentWillUnmount() {
    if (this.props.detachInputComponent) {
      this.props.detachInputComponent(this); // Detaching if unmounting
    }
  }

  onChange(event) {
    const value = event.target.value;
    this.setState({ value }, () => {
      // trigger this.getErrors to show/hide errors
      this.getErrors();
      if (this.isValid(value)) {
        this.props.onChange({
          target: this,
          value,
          name: this.props.name,
          parent: this.props.parentName
        });
      } else {
        this.props.onError({
          target: this,
          value,
          name: this.props.name,
          parent: this.props.parentName
        });
      }
    });
  }

  onFocus() {
    this.setState({ focus: true });
  }

  onBlur() {
    this.setState({ focus: false });
  }

  getErrors() {
    const value = this.getValue(true);
    const errors = [];
    if (
      this.props.required &&
      (value === "" ||
        value == null ||
        (["integer", "float"].includes(this.props.filters) && isNaN(value)))
    ) {
      errors.push({ type: "required", text: this.props.requiredErrorText });
    }

    const validators = this.props.validators;
    if (typeof validators === "object") {
      Object.keys(validators).forEach(type => {
        const validationOptions = validators[type];
        if (!validationRules[type](value, ...validationOptions)) {
          errors.push({ type, text: this.props.errorText });
        }
      });
    } else if (typeof validators === "string" && validators !== "") {
      if (!validationRules[validators](value)) {
        errors.push({ type: validators, text: this.props.errorText });
      }
    } else if (typeof validators === "function") {
      if (!validators(value)) {
        errors.push({ type: "func", text: this.props.errorText });
      }
    }

    this.setState({ errors });
    return errors;
  }

  getValue(applyFilters) {
    return applyFilters
      ? this.applyFilters(this.state.value)
      : this.state.value;
  }

  getInputName() {
    if (this.props.name === "") {
      return this.props.parentName;
    }
    return this.props.parentName !== ""
      ? `${this.props.parentName}[${this.props.name}]`
      : this.props.name;
  }

  getInputID() {
    return this.getInputName().replace(/^[^a-z]+|[^\w:.-]+/gi, "");
  }

  applyFilters(value) {
    // TODO: filters should be optionally an array
    let filteredValue;
    if (typeof this.props.filters === "function") {
      filteredValue = this.props.filters(value);
    } else {
      switch (this.props.filters) {
        case "integer":
          filteredValue = parseInt(value, 10);
          break;
        case "float":
          // TODO: fix this logix - this is a hack
          filteredValue =
            typeof value === "string" && value.endsWith(".")
              ? value
              : parseFloat(value);
          // console.info('filteredValue', filteredValue);
          // filteredValue = value;
          break;
        case "boolean":
          if (typeof value === "boolean") {
            filteredValue = value;
          } else if (value === "1" || (typeof value === "string" && value.toLowerCase() === "true")) {
            filteredValue = true;
          } else if (value === "0" || (typeof value === "string" && value.toLowerCase() === "false")) {
            filteredValue = false;
          } else {
            filteredValue = Boolean(value);
          }
          break;
        case "date":
          filteredValue = value.toDate();
          break;
        default:
          filteredValue = value;
          break;
      }
    }
    return filteredValue;
  }

  subfieldsQuery() {
    return typeof this.props.subfieldsQuery === "function"
      ? this.props.subfieldsQuery()
      : null;
  }

  valueTransformOut(value) {
    return typeof this.props.valueTransformOut === "function"
      ? this.props.valueTransformOut(value)
      : value;
  }

  valueTransformIn(value) {
    return typeof this.props.valueTransformIn === "function"
      ? this.props.valueTransformIn(value)
      : value;
  }

  isValid(value) {
    let isValid = true;
    if (
      this.props.required &&
      (value === "" ||
        value == null ||
        (["integer", "float"].includes(this.props.filters) && isNaN(value)))
    ) {
      isValid = false;
    }

    const validators = this.props.validators;
    if (typeof validators === "object") {
      Object.keys(validators).forEach(type => {
        const validationOptions = validators[type];
        if (!validationRules[type](value, ...validationOptions)) {
          isValid = false;
        }
      });
    } else if (typeof validators === "string" && validators !== "") {
      if (!validationRules[validators](value)) {
        isValid = false;
      }
    } else if (typeof validators === "function") {
      isValid = validators(value);
    }
    return isValid;
  }

  render() {
    let inputClass = "";
    if (this.state.focus === true) {
      inputClass = "is-active";
    }
    if (
      ["integer", "float"].includes(this.props.filters) &&
      !isNaN(this.state.value) &&
      this.state.value != null
    ) {
      inputClass = "is-active";
    } else if (
      !["integer", "float"].includes(this.props.filters) &&
      this.state.value !== "" &&
      this.state.value !== null
    ) {
      inputClass = "is-active";
    }
    const inputID = this.getInputID();

    return (
      <Group inputID={inputID} errors={this.state.errors} {...this.props}>
        <input
          type={
            this.inputClass === "password"
              ? this.state.passwordType
              : this.inputType
          }
          id={inputID}
          name={this.getInputName()}
          className={`form-m__input ${inputClass}`}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          value={this.state.value != null ? this.state.value : ""}
          onChange={this.onChange}
          disabled={this.props.disabled}
          readOnly={this.props.readOnly}
          autoComplete={this.props.autoComplete}
        />
        {this.inputClass === "password" && (
          <button
            className="form-m__passwordButton"
            type="button"
            onClick={() => {
              if (this.state.passwordType === "password") {
                this.setState({ passwordType: "text" });
              } else {
                this.setState({ passwordType: "password" });
              }
            }}
          >
            <Icon
              icon={this.state.passwordType === "password" ? "eye" : "eyeSlash"}
            />
          </button>
        )}
      </Group>
    );
  }
}

export default Base;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Base.js